import React, { ComponentType, ReactNode } from 'react'
import { View } from 'src/ui/basic/View'
import {
    verticalChildSpacing,
    verticalPaddedContent
} from 'src/ui/style/mixins/layout'
import { useTheme } from 'src/ui/style/useTheme'
import { mediaMaxWidth } from 'src/ui/style/mixins/helpers'
import { css } from 'src/ui/style/css'

export type SectionedPage = {
    children: ReactNode
    className?: string
}

export const CardListSection: ComponentType<SectionedPage> = ({
    children,
    className
}) => {
    const th = useTheme()
    const spacing = th.spacing.lg
    return (
        <View
            className={className}
            css={[
                verticalChildSpacing(spacing)(th),
                verticalPaddedContent()(th),
                css`
                    // Sets same responsive child spacing as responsive padding of content
                    ${mediaMaxWidth(th.screens.md)} {
                        ${verticalChildSpacing(th.spacing.md)(th)};
                    }
                `
            ]}
        >
            {children}
        </View>
    )
}
